// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dfa197e2","455":"ed9b8626"}[chunkId] + ".chunk.js";
};